import {
  ActivatedRouteSnapshot,
  Params,
  RouterStateSnapshot,
} from '@angular/router';
import * as fromRouter from '@ngrx/router-store';
import {
  ActionReducerMap,
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';

import * as fromNotification from './notification.reducer';

// ToDo separate selectors for each feature
export interface AppState {
  ngrxRouter: fromRouter.RouterReducerState<RouterState>;
  notification: fromNotification.State;
}
export const reducers: ActionReducerMap<AppState> = {
  ngrxRouter: fromRouter.routerReducer,
  notification: fromNotification.reducer,
};
// router slice
export interface RouterState {
  url: string;
  queryParams: Params;
  params: Params;
}
export const getRouterState =
  createFeatureSelector<fromRouter.RouterReducerState<RouterState>>(
    'ngrxRouter'
  );
// serialize angular router state into ngrxRouter
export class CustomRouterSerializer
  implements fromRouter.RouterStateSerializer<RouterState>
{
  serialize(routerState: RouterStateSnapshot): RouterState {
    const { url } = routerState;
    const { queryParams } = routerState.root;
    let state: ActivatedRouteSnapshot = routerState.root;
    while (state.firstChild) {
      state = state.firstChild;
    }
    const { params } = state;
    return { url, queryParams, params };
  }
}
export const getNgrxRouterParams = createSelector(
  getRouterState,
  (routerState) => routerState && routerState.state && routerState.state.params
);

// notification
export const notificationState = (state: AppState) => state.notification;
export const getNotificationMessage = createSelector(
  notificationState,
  (notification) => notification.message
);
